import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import Select from "react-select";
import CustomSelect from "../../../core/common/commonSelect";
import { all_routes } from "../../router/all_routes";

const AgentSettings = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const routes = all_routes;
  const navigate = useNavigate();

  const [selectedPhoto, setSelectedPhoto] = useState<File | null>(null);
  const [selectedPhotoPreview, setSelectedPhotoPreview] = useState<string | null>(null);

  const [agentData, setAgentData] = useState({
    id: 0,
    nome: '',
    email: '',
    telefone: '',
    bi: '',
    nacionalidade: '',
    endereco: '',
    pais: '',
    estado: '',
    cidade: '',
    cep: '',
    idiomas: [] as string[],
    antecedentesCriminais: '',
    foto: {
      id: 0,
      url: '',
      tipo: '',
    } as any,
  });

  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [hasCriminalRecord, setHasCriminalRecord] = useState(false);
  const geoNamesUser = 'jvsgeoapi';

  useEffect(() => {
    fetchCountries();
    loadAgentData();
  }, []);

  const fetchCountries = async () => {
    const res = await axios.get(`http://api.geonames.org/countryInfoJSON?username=${geoNamesUser}`);
    setCountries(res.data.geonames.map((country: any) => ({
      label: country.countryName,
      value: String(country.countryCode),
      geonameId: country.geonameId
    })));
  };

  const fetchStates = async (geonameId: number) => {
    const res = await axios.get(`http://api.geonames.org/childrenJSON?geonameId=${geonameId}&username=${geoNamesUser}`);
    setStates(res.data.geonames.map((region: any) => ({
      label: region.name,
      value: String(region.adminCode1 || region.name)
    })));
  };

  const fetchCities = async (countryCode: string, adminCode1: string) => {
    const res = await axios.get(`http://api.geonames.org/searchJSON?country=${countryCode}&adminCode1=${adminCode1}&featureClass=P&maxRows=1000&username=${geoNamesUser}`);
    setCities(res.data.geonames.map((city: any) => ({
      label: city.name,
      value: String(city.name)
    })));
  };

  const loadAgentData = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${BASE_URL}/usuarios/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAgentData({
        ...res.data,
        foto: res.data.foto || { id: 0, url: '', tipo: '' }
      });
      setHasCriminalRecord(!!res.data.antecedentesCriminais);
    } catch (err) {
      console.error("Erro ao carregar agente", err);
    }
  };

  useEffect(() => {
    if (countries.length > 0 && agentData.pais) {
      const selectedCountry = countries.find(c => c.label === agentData.pais);
      if (selectedCountry) fetchStates(selectedCountry.geonameId);
    }
  }, [countries, agentData.pais]);

  useEffect(() => {
    if (states.length && agentData.pais && agentData.estado) {
      const selectedCountry = countries.find(c => c.label === agentData.pais);
      const selectedState = states.find(s => s.label === agentData.estado);
      if (selectedCountry && selectedState) {
        fetchCities(selectedCountry.value, selectedState.value);
      }
    }
  }, [states, agentData.pais, agentData.estado]);

  const handleChange = (field: keyof typeof agentData, value: string | string[]) => {
    setAgentData(prev => ({ ...prev, [field]: value }));
  };

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedPhoto(file);
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) setSelectedPhotoPreview(event.target.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.put(`${BASE_URL}/usuarios/me`, agentData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (selectedPhoto) {
        const formData = new FormData();
        formData.append("file", selectedPhoto);

        const response = await axios.put(`${BASE_URL}/usuarios/me/foto`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        const fotoUrl = response.data.fotoUrl;
        const novaFotoId = fotoUrl.split("/").pop();

        setAgentData((prev) => ({
          ...prev,
          foto: {
            id: novaFotoId,
            url: fotoUrl,
          },
        }));

        setSelectedPhoto(null);
        setSelectedPhotoPreview(null);
      }

      alert("Perfil atualizado com sucesso!");
      navigate("/agent/my-profile");
    } catch (err) {
      console.error("Erro ao salvar dados", err);
      alert("Erro ao salvar alterações.");
    }
  };

  const breadcrumbs = [
    { label: 'Settings', link: routes.home1, active: false },
    { label: 'Agent Settings', active: true }
  ];

  return (
    <div>
      <Breadcrumb title="Settings" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-04" />
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-4">
              {agentData && (
                <Sidebar
                />
              )}
            </div>
            <div className="col-xl-9 col-lg-8">
              <div className="card settings mb-0">
                <div className="card-header">
                  <h6>Agent Settings</h6>
                </div>
                <div className="card-body pb-3">
                  <div className="settings-link d-flex align-items-center flex-wrap">
                    <Link to={routes.agentSettings} className="active ps-3">
                      <i className="isax isax-user-octagon me-2" />
                      Profile Settings
                    </Link>
                    <Link to={routes.agentAccountSettings}><i className="isax isax-wallet-money me-2" />
                    Company info 
                    </Link>
                    <Link to={routes.agentContract}>
                      <i className="isax isax-document-text me-2" /> Contract
                    </Link>
                    <Link to={routes.agentSecuritySettings}><i className="isax isax-shield-tick me-2" />
                    Security
                    </Link>
                    <Link to={routes.agentPlanSettings}><i className="isax isax-star me-2" />
                    Plans & Billing
                    </Link>
                  </div>

                  {/* Foto de Perfil */}
                  <div className="settings-content mb-4">
                    <h6 className="fs-16 mb-3">Foto de Perfil</h6>
                    <div className="d-flex align-items-center gap-3">
                      {selectedPhotoPreview ? (
                        <img src={selectedPhotoPreview} alt="Foto Preview" style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover" }} />
                      ) : agentData?.foto?.id ? (
                        <img src={`${BASE_URL}/uploads/${agentData.foto.id}?v=${Date.now()}`} alt="Foto de Perfil" style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover" }} />
                      ) : (
                        <div style={{ width: 60, height: 60, backgroundColor: "#ccc", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                          {agentData?.nome?.[0]?.toUpperCase() || "A"}
                        </div>
                      )}
                      <label className="btn btn-outline-primary btn-sm mb-0" style={{ cursor: "pointer" }}>
                        Alterar Foto
                        <input type="file" accept="image/*" onChange={handlePhotoChange} style={{ display: "none" }} />
                      </label>
                    </div>
                  </div>

                  <div className="settings-content mb-3">
                    <h6 className="fs-16 mb-3">Basic Information</h6>
                    <div className="row gy-2">
                      <div className="col-lg-6">
                        <label className="form-label">Full Name</label>
                        <input type="text" className="form-control" value={agentData.nome} onChange={(e) => handleChange("nome", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Nationality</label>
                        <input type="text" className="form-control" value={agentData.nacionalidade} onChange={(e) => handleChange("nacionalidade", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Email</label>
                        <input type="email" className="form-control" value={agentData.email} onChange={(e) => handleChange("email", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">BI (Bilhete de Identidade)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={agentData.bi}
                          onChange={(e) => handleChange("bi", e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Phone</label>
                        <input type="text" className="form-control" value={agentData.telefone} onChange={(e) => handleChange("telefone", e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <label className="form-label">Languages Spoken</label>
                      <Select
                        isMulti
                        options={[
                          { label: 'English', value: 'English' },
                          { label: 'Portuguese', value: 'Portuguese' },
                          { label: 'Spanish', value: 'Spanish' },
                          { label: 'French', value: 'French' },
                          { label: 'German', value: 'German' },
                        ]}
                        value={(agentData.idiomas || []).map(idioma => ({ label: idioma, value: idioma }))}
                        onChange={(selected) =>
                          handleChange(
                            'idiomas',
                            Array.isArray(selected) ? selected.map(item => item.value) : []
                          )
                        }
                      />
                    </div>
                    <div className="row gy-2 mt-3">
                      <div className="col-lg-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="antecedentesCheck"
                            checked={hasCriminalRecord}
                            onChange={(e) => {
                              setHasCriminalRecord(e.target.checked);
                              if (!e.target.checked) {
                                handleChange("antecedentesCriminais", ""); // limpa o campo ao desmarcar
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor="antecedentesCheck">
                            Possui antecedentes criminais?
                          </label>
                        </div>
                      </div>

                      {hasCriminalRecord && (
                        <div className="col-lg-6">
                          <label className="form-label">Antecedentes Criminais</label>
                          <input
                            type="text"
                            className="form-control"
                            value={agentData.antecedentesCriminais}
                            onChange={(e) => handleChange("antecedentesCriminais", e.target.value)}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="settings-content">
                    <h6 className="fs-16 mb-3">Address Information</h6>
                    <div className="row gy-2">
                      <div className="col-lg-12">
                        <label className="form-label">Address</label>
                        <input type="text" className="form-control" value={agentData.endereco} onChange={(e) => handleChange("endereco", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Country</label>
                        <CustomSelect
                          options={countries}
                          placeholder="Select"
                          value={countries.find(opt => opt.label === agentData.pais)}
                          onChange={(e) => {
                            handleChange("pais", e?.label || "");
                            handleChange("estado", "");
                            handleChange("cidade", "");
                          }}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">State</label>
                        <CustomSelect
                          options={states}
                          placeholder="Select"
                          value={states.find(opt => opt.label === agentData.estado)}
                          onChange={(e) => {
                            handleChange("estado", e?.label || "");
                            handleChange("cidade", "");
                          }}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">City</label>
                        <CustomSelect
                          options={cities}
                          placeholder="Select"
                          value={cities.find(opt => opt.label === agentData.cidade)}
                          onChange={(e) => handleChange("cidade", e?.label || "")}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Postal Code</label>
                        <input type="text" className="form-control" value={agentData.cep} onChange={(e) => handleChange("cep", e.target.value)} />
                      </div>
                    </div>
                  </div>

                </div>
                <div className="card-footer">
                  <div className="d-flex align-items-center justify-content-end">
                    <Link to="/agent/my-profile" className="btn btn-light me-2">Cancelar</Link>
                    <button className="btn btn-primary" onClick={handleSave}>Salvar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentSettings;
